// import React from 'react';
import { Route, Switch } from 'react-router-dom';
import _ from 'lodash';
import { IfmsRoute } from './types';

import InvalidOperation from '../InvalidOperation';
import NotFound from '../NotFound';

import commonRoutes from '../components/common/routes';
import referenceFilesRoutes from '../components/referenceFiles/routes';
import setupRoutes from '../components/setup/routes';
import accountingRoutes from '../components/accounting/routes';
import airExportRoutes from '../components/airExport/routes';
import airImportRoutes from '../components/airImport/routes';
import oceanExportRoutes from '../components/oceanExport/routes';
import oceanImportRoutes from '../components/oceanImport/routes';
import otherShipmentRoutes from '../components/otherShipment/routes';
import warehousingRoutes from '../components/warehousing/routes';
import homeRoutes from '../components/home/routes';
import opReportRoutes from '../components/opReport/routes';
import amsRoutes from '../components/ams/routes';
import isfRoutes from '../components/isf/routes';
import myTaskRoutes from '../components/myTask/routes';

export const IfmsAppRoutes = [
  ...commonRoutes,
  ...referenceFilesRoutes,
  ...setupRoutes,
  ...accountingRoutes,
  ...airExportRoutes,
  ...airImportRoutes,
  ...oceanExportRoutes,
  ...oceanImportRoutes,
  ...otherShipmentRoutes,
  ...warehousingRoutes,
  ...opReportRoutes,
  ...amsRoutes,
  ...isfRoutes,
  ...myTaskRoutes,
  ...homeRoutes,
];

const routeExpander = (routes:Array<IfmsRoute>) => routes.map( r => <Route exact key={_.uniqueId('route-')} path={r.path} component={r.component} />);

const routes = (
  <Switch>
    {routeExpander(IfmsAppRoutes)}
    <Route path="/invalidOperation" component={InvalidOperation} />
    <Route path="/" component={NotFound} />
  </Switch>
);

export default routes;